import { LoaderFunctionArgs } from "react-router";
import { Outlet } from "react-router";
import { useLocation } from "react-router";

import AdAside from "~/components/ads/AdAside";
import { getLocale } from "~/i18n";


export const loader = async ({ request }: LoaderFunctionArgs) => {
  // This will ensure that invalid locales do not render page
  const locale = getLocale(request.url);
  if (locale === null) {
    throw new Response(null, { status: 404 });
  }

  return null;
};

export default function Index() {
  const locale = getLocale(useLocation().pathname);

  return (
    <div className="w-full flex flex-row gap-6">
      <main className="flex flex-col w-full items-start justify-start min-w-0">
        <Outlet />
      </main>
      <aside className="hidden lg:flex flex-col md:w-[250-px] lg:w-[300px] 2xl:w-[400px] shrink-0 relative">
        <div className="sticky top-4 flex flex-col gap-4">
          { locale === "ru"
            ? <AdAside type="yandex" adId="R-A-7013740-1" />
            : <AdAside type="google" adId="8042944538" />
          }
          {/*<AdAside adId="R-A-7013740-4" />*/}
        </div>
      </aside>
    </div>
  );
}
